import  "./index.scss";
import { useLanguage } from "@/app/utils/LanguageContext";
import Remarks from "@/app/ui/Common/remarks";
import { compareDate, formattedDate} from "@/app/utils/DayJS";

const NoInformation = (props:any) => {
    const { state: lang } = useLanguage();
    const { t } = lang;
    const { PageName, DirectPageName, type, pageRemark, ssn_end = false } = props;
    // lang?.langCode == "en-us"

    const displaySeasonEndMessage = (): boolean => {
        const startDate = window.globalConfig?.OTHERS?.SEASONEND_MESSAGE_STARTDATE;
        const endDate = window.globalConfig?.OTHERS?.SEASONEND_MESSAGE_ENDDATE;
        if (!startDate || !endDate) {
            return false;
        }
        const today = formattedDate(new Date(), "YYYYMMDD");
        return (
            compareDate(today, startDate, "after", true) &&
            compareDate(today, endDate, "before", true)
        );
    };
    const showSeasonEndMessage = ssn_end && displaySeasonEndMessage();
    const isZh = lang?.langCode?.toLowerCase() === "zh-hk";
    const seasonEndLink = isZh
        ? window.globalConfig?.OTHERS?.SSN_END_LINK_DESTINATION_ZH
        : window.globalConfig?.OTHERS?.SSN_END_LINK_DESTINATION_EN;
    const seasonEndImg = isZh
        ? window.globalConfig?.OTHERS?.SSN_END_IMG_ZH
        : window.globalConfig?.OTHERS?.SSN_END_IMG_EN;

    //timeout, noinfo, willbeavailable
    let errorMsg ="";
    switch (type?.toLowerCase()) {
        case "timeout":
            errorMsg = t("error_Timeout");
            break;
        case "noinfo":
            errorMsg = t("error_Noinformation");
            break;
        case "inforeleasedshortly":
            errorMsg = t("error_info_willreleasedshortly");
            break;
        default:
            errorMsg = t("error_willbeavailable").replace("{{PageName}}", PageName).replace("{{DirectPageName}}", DirectPageName);
            break;
    }

    return (
        <>
        {showSeasonEndMessage ? (
            <div className="commContent">
                <div style={{ minHeight: "350px" }}>
                    <a href={seasonEndLink} target="_blank">
                        <img src={seasonEndImg} alt="" style={{ width: "920px" }} />
                    </a>
                </div>
            </div>
        ) : (
            <div className="commContent noinformation">
                <div className="errorout">
                    <div className="errorleft" dangerouslySetInnerHTML={{ __html: t("errorleft").replace("{0}","//" + window?.globalConfig?.LINKED_PAGES.HOMEPAGEENG?.split('/')?.filter((i:any) => i != "")?.[0] )}} >
                    </div>
                    <div className="errorright" dangerouslySetInnerHTML={{ __html: errorMsg}}>
                    </div>
                    { type==="willbeavailable" && pageRemark ? <Remarks path={pageRemark} hideAdditionalRemark={true} customClass=""/> : <></> }
                </div>
            </div>
        )}
        </>
    )
}

export default NoInformation;
